import React, { useState, useEffect } from "react";
import "../createaccount/create.css";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { putwithoutAPI, postWithoutTokenAPI } from "../../utils/Api";
import { useLocation, useNavigate } from "react-router-dom";

const Createaccount = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const phone_number = location.state?.phone_number;

    const [showPassword, setShowPassword] = useState(false);
    const [name, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [termsAccepted, setTermsAccepted] = useState(false);

    const profile_image = "https://img.freepik.com/free-vector/isolated-young-handsome-man-different-poses-white-background-illustration_632498-855.jpg?semt=ais_hybrid&w=740";
    const role = "seller";

    useEffect(() => {
        if (!phone_number) {
            setError("Missing phone number. Please try again.");
            setTimeout(() => navigate("/admin/creates"), 2000);
        } else {
            console.log("Phone number loaded:", phone_number);
        }
    }, [phone_number, navigate]);

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const validatePassword = (password) => {
        const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
        return regex.test(password);
    };

    const checkIfExists = async () => {
        try {
            const response = await postWithoutTokenAPI("/user/check-existence", { email, name });
            return response.exists;
        } catch (err) {
            setError("Error checking username or email.");
            return false;
        }
    };

    const handleSubmit = async () => {
        setError("");
        setSuccess("");

        if (!name || !email || !password) {
            setError("All fields are required.");
            return;
        }

        if (!termsAccepted) {
            setError("You must accept the terms and conditions.");
            return;
        }

        if (!validatePassword(password)) {
            setError("Password must be at least 8 characters long, include at least one number and one special character.");
            return;
        }

        const exists = await checkIfExists();
        if (exists) {
            setError("Username or email already exists.");
            return;
        }

        try {
            const response = await putwithoutAPI("/user/update", {
                phone_number,
                name,
                email,
                password,
                profile_image,
                role,
            });

            if (response?.statusCode === 200 || response?.success) {
                setSuccess("Account created successfully!");
                setTimeout(() => navigate("/backoffice/admin/login"), 1500);
                console.log("Success:", response);
            } else {
                setError(response?.message || "Failed to update user.");
                console.log("Error Response:", response);
            }
        } catch (err) {
            console.error("API Error:", err);
            setError("An error occurred while updating account.");
        }
    };

    return (
        <div className="auth-box">
            <h2 className="auth-title">Create Account</h2>

            <div className="auth-field">
                <input
                    className="auth-input"
                    type="text"
                    placeholder="Enter your Username"
                    value={name}
                    onChange={(e) => setUsername(e.target.value)}
                />
            </div>

            <div className="auth-field">
                <input
                    className="auth-input"
                    type="email"
                    placeholder="Enter your Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
            </div>

            <div className="auth-field">
                <div className="auth-password-wrapper">
                    <input
                        className="auth-input"
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter your Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <span className="auth-eye-icon" onClick={togglePasswordVisibility}>
                        {showPassword ? <FiEye /> : <FiEyeOff />}
                    </span>
                </div>
            </div>

            <div className="auth-links">
                <div className="auth-remember-section">
                    <input 
                        type="checkbox"
                        id="remember"
                        checked={termsAccepted}
                        onChange={(e) => setTermsAccepted(e.target.checked)} 
                    />
                    <label htmlFor="remember" className="auth-remember-label">
                        Accept all terms & Conditions
                    </label>
                </div>
            </div>

            {error && <div className="auth-error">{error}</div>}
            {success && <div className="auth-success">{success}</div>}

            <button className="auth-button" onClick={handleSubmit}>
                Create Account
            </button>

            <div className="auth-signup-link">
                <span>Already have an account?</span>
                <a href="/login">Login</a>
            </div>
        </div>
    );
};

export default Createaccount;
